import { gql } from "graphql-request";

export const GET_USER_PROFILES = gql`
  query GetUserProfiles(
    $filter: String!
    $sort: String!
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getuserprofiles(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationIds
        Tags
        DeletedDate
        gender
        dob
        designation
        department
        company
        website
        address
        country
        description
        backgroundImageUrl
        wikiSaved
        newsSaved
        wikiDraftIds
        newsDraftIds
        savedPostIds
      }
    }
  }
`;

export const GET_USER_PROFILE_COUNTRIES = gql`
  query GetUserProfileCountries(
    $filter: String!
    $sort: String!
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getuserprofiles(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      items {
        CreatedBy
        country
      }
    }
  }
`;

export const GET_USER_PREFERENCES_QUERY = gql`
  query GetUserPreferences($filter: String, $sort: String) {
    getuserprofiles(input: { filter: $filter, sort: $sort }) {
      items {
        ItemId
        CreatedBy
        preferences {
          language
          lightMode
        }
      }
    }
  }
`;

export const CREATE_USER_PREFERENCES_MUTATION = gql`
  mutation InsertUserProfile(
    $filter: String!
    $language: String
    $lightMode: Boolean
    $organizationIds: [String]
  ) {
    insertuserprofile(
      input: {
        OrganizationIds: $organizationIds
        preferences: { language: $language, lightMode: $lightMode }
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_USER_PREFERENCES_MUTATION = gql`
  mutation UpdateUserProfile(
    $filter: String!
    $language: String
    $lightMode: Boolean
  ) {
    updateuserprofile(
      filter: $filter
      input: { preferences: { language: $language, lightMode: $lightMode } }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const INSERT_USER_PROFILE = gql`
  mutation InsertUserProfile(
    $gender: String
    $dob: String
    $designation: String
    $department: String
    $company: String
    $website: String
    $address: String
    $country: String
    $description: String
    $backgroundImageUrl: String
    $newsSaved: [String]
    $newsDraftIds: [String]
    $organizationIds: [String]
  ) {
    insertuserprofile(
      input: {
        OrganizationIds: $organizationIds
        gender: $gender
        dob: $dob
        designation: $designation
        department: $department
        company: $company
        website: $website
        address: $address
        country: $country
        description: $description
        backgroundImageUrl: $backgroundImageUrl
        newsSaved: $newsSaved
        newsDraftIds: $newsDraftIds
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile(
    $filter: String!
    $gender: String
    $dob: String
    $designation: String
    $department: String
    $company: String
    $website: String
    $address: String
    $country: String
    $description: String
    $backgroundImageUrl: String
    $archivedEventIds: [String!]
    $wikiSaved: [String]
    $newsSaved: [String]
    $wikiDraftIds: [String]
    $newsDraftIds: [String]
  ) {
    updateuserprofile(
      filter: $filter
      input: {
        gender: $gender
        dob: $dob
        designation: $designation
        department: $department
        company: $company
        website: $website
        address: $address
        country: $country
        description: $description
        backgroundImageUrl: $backgroundImageUrl
        archivedEventIds: $archivedEventIds
        wikiSaved: $wikiSaved
        newsSaved: $newsSaved
        wikiDraftIds: $wikiDraftIds
        newsDraftIds: $newsDraftIds
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_USER_PROFILE = gql`
  mutation DeleteUserProfile($filter: String!) {
    deleteuserprofile(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every profile created by a user (used by the user-deletion purge).
export const DELETE_MANY_USER_PROFILE_BY_CREATOR = gql`
  mutation DeleteManyUserProfileByCreator($createdBy: String!) {
    deleteManyuserprofile(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

// Post saves
export const UPDATE_USER_SAVED_POSTS_MUTATION = gql`
  mutation UpdateUserSavedPosts($filter: String!, $savedPostIds: [String]!) {
    updateuserprofile(filter: $filter, input: { savedPostIds: $savedPostIds }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_POST_SAVE_COUNT_MUTATION = gql`
  mutation UpdatePostSaveCount($filter: String!, $saveCount: Int!) {
    updatepost(filter: $filter, input: { saveCount: $saveCount }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const GET_USER_GROUP_IDS = gql`
  query GetUserProfileGroupIds($filter: String!) {
    getuserprofiles(input: { filter: $filter }) {
      items {
        groupIds
      }
    }
  }
`;

export const GET_ALL_USER_PROFILES = gql`
  query GetAllUserProfiles($month: String, $orgId: String) {
    getuserprofiles(
      where: {
        dob: { contains: $month }
        OrganizationIds: { contains: $orgId }
      }
      order: []
      paging: { pageNo: 1, pageSize: 100 }
    ) {
      items {
        ItemId
        CreatedBy
        dob
      }
      totalCount
    }
  }
`;
